module.exports = __webpack_public_path__ + "img/ico-interactive-platform_3.0d71c1bc.svg";